import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {Box} from '@primer/react'

export const MetadataSidebarLoading = () => {
  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 3, flexWrap: 'wrap', mt: 1}}>
      <SectionLoading />
      <SectionLoading />
      <SectionLoading />
      <SectionLoading />
    </Box>
  )
}

const SectionLoading = () => {
  return (
    <>
      <LoadingSkeleton variant="rounded" height="xl" width="100%" />
      <LoadingSkeleton variant="rounded" height="lg" width="50%" />
    </>
  )
}

try{ MetadataSidebarLoading.displayName ||= 'MetadataSidebarLoading' } catch {}
try{ SectionLoading.displayName ||= 'SectionLoading' } catch {}